export default {
  siteId: "26",
  siteName: "eu",
  site: "eu",
  lang: "Dutch",
  langCode: "nl-BE",
  MediaType: "Ondersteunde bestandstypen zijn JPEG, JPG, PNG of MP4.",
  MediaReward: "Deel foto's of video's om speciale beloningen te ontgrendelen.",
  RewardQa: "Beantwoord alle onderstaande vragen voor extra beloningen.",
  MoreQa: "Klik om meer vragen in te vullen.",
  RewardsToast: "Uw beloning is succesvol bijgeschreven op uw account.",
  subscribe1:
    "Je bent succesvol uitgeschreven voor de marketingberichten van Cupshe EU.",
  subscribe2: "Wilde je je niet uitschrijven?",
  subscribe3: "RESUBSCRIBE",
  subscribe4: "Je bent ingeschreven voor Cupshe NL's marketingberichten.",
  "You're already on the list!": "Je staat al op de lijst! :)",
  "Oops, there was a hiccup!Please try again.":
    "Oeps, er was een hik! Probeer het opnieuw.",
  mailContact:
    'Neem contact op met de <a href="https://eu.cupshe.com/pages/contact-us" class="contact_link">klantenservice</a> voor assistentie.',
  policyText:
    "*Houd er rekening mee dat je, nadat je je hebt uitgeschreven, e-mails kunt ontvangen met contractuele informatie over je toekomstige online aankopen. Bijvoorbeeld orderbevestiging, verzendbericht, terugbetalingsbericht, etc.).",
};
